/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidacyListItemDataSchema = z.object({
	id: z.string(),
	campaignTitle: z.string(),
	logoUrl: z.string().nullable(),
	submittedAt: z.iso.datetime(),
	cvUploadedAt: z.iso.datetime().nullable(),
})

export type CandidacyListItemDataSchema = z.infer<typeof candidacyListItemDataSchema>
